import { useEffect, useState } from "react";

/**
 * React hook to only update a value after a debounce timeout
 */
export const useDebounce = (value: any, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    // Used to delay the setting of the value
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      // Cleanup timeout on unmount or if useEffect is recalled (value changed)
    }, delay);
    // this is what keeps the debouncing happening since the previous timeout
    // will be cleaned up when the value changes and the timeout will never complete
    // until the timeout has completed before the next change.

    return () => {
      clearTimeout(handler);
    };
  }, [delay, value]);
  return debouncedValue;
};

export default useDebounce;
